import { boot } from 'quasar/wrappers'

const rules = {
  required: (v) => !!v || 'Este campo es requerido',
  email: (v) => v === undefined || v === null || v === '' || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'El e-mail es invalido',
}

export default boot(({ app }) => {
  app.config.globalProperties.$rules = rules
})

